export default __webpack_public_path__ + "static/media/pencil-fill.915658c3.svg";